import { forwardRef } from 'react';
import { CardElementProps, CardRef } from '@type/card';


// Card Body
// ***************************************************************
export const CardBody = forwardRef<CardRef, CardElementProps>((props, ref) => {
  // destructure props
  const {
    className = '',
    children = 'Card body',
    ...restProps
  } = props;

  return (
    <div ref={ref} className={`grow p-3 ${className}`} {...restProps}>
      { children }
    </div>
  );
});
